/* tslint:disable */

declare var Object: any;
export interface PositionInterface {
  "id"?: number;
}

export class Position implements PositionInterface {
  "id": number;
  constructor(data?: PositionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Position`.
   */
  public static getModelName() {
    return "Position";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Position for dynamic purposes.
  **/
  public static factory(data: PositionInterface): Position{
    return new Position(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Position',
      plural: 'Positions',
      path: 'Positions',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Position.ts